var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import DynamicTable from "@atlaskit/dynamic-table";
import Avatar from '@atlaskit/avatar';
import WorkflowModal from "./workflow-modal";
import styled from "styled-components";
import moment from 'moment';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import RecentIcon from '@atlaskit/icon/glyph/recent';
import Tooltip from '@atlaskit/tooltip';
import InProgress from './in-progress.png';
var NameWrapper = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var AvatarWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 8px;\n"], ["\n  margin-right: 8px;\n"])));
var Link = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var AnimatedIcon = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 24px;\n  min-height: 24px;\n  width: 24px;\n  min-width: 24px;\n  animation: rotation 3s infinite ease;\n\n  @keyframes rotation {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(1079deg);\n    }\n  }\n"], ["\n  height: 24px;\n  min-height: 24px;\n  width: 24px;\n  min-width: 24px;\n  animation: rotation 3s infinite ease;\n\n  @keyframes rotation {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(1079deg);\n    }\n  }\n"])));
var IconWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  > div {\n    display: flex;\n    align-items: center;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  > div {\n    display: flex;\n    align-items: center;\n  }\n"])));
var head = {
    cells: [
        {
            key: 'id',
            content: 'ID',
            shouldTruncate: true
        },
        {
            key: 'startedAt',
            content: 'Started',
            width: 18
        },
        {
            key: 'completedAt',
            content: 'Completed',
            width: 18
        },
        {
            key: 'duration',
            content: 'Duration',
            width: 15
        },
        {
            key: 'status',
            content: '',
            width: 5
        }
    ]
};
export var getStatusIcon = function (status) {
    switch (status) {
        case 'RUNNING':
            return (React.createElement(Tooltip, { position: "right", content: getStatus(status) },
                React.createElement(IconWrapper, null,
                    React.createElement(AnimatedIcon, null,
                        React.createElement("img", { src: InProgress, width: "100%", height: "100%", alt: "in-progress icon" })))));
        case 'PENDING':
            return (React.createElement(Tooltip, { position: "right", content: getStatus(status) },
                React.createElement(RecentIcon, { label: getStatus(status), primaryColor: "#6054BB" })));
        case 'COMPLETED':
            return (React.createElement(Tooltip, { position: "right", content: getStatus(status) },
                React.createElement(CheckCircleIcon, { label: getStatus(status), primaryColor: "#36B37E" })));
        case 'FAILED':
            return (React.createElement(Tooltip, { position: "right", content: getStatus(status) },
                React.createElement(CrossCircleIcon, { label: getStatus(status), primaryColor: "#FF5630" })));
        default:
            return 'default';
    }
};
export var getStatus = function (status) {
    switch (status) {
        case 'RUNNING':
            return 'IN PROGRESS';
        case 'PENDING':
            return 'PENDING';
        case 'COMPLETED':
            return 'COMPLETED';
        case 'FAILED':
            return 'FAILED';
        default:
            return 'UNKNOWN';
    }
};
export var statusDone = function (status) { return status === 'COMPLETED' || status === 'FAILED'; };
export var getDurationString = function (startedAt, updatedAt, status, current) {
    if (statusDone(status)) {
        var duration = moment.duration(moment(updatedAt).diff(moment(startedAt)));
        return "" + (duration.days() ? duration.days() + 'd ' : ' ') + (duration.hours() ? duration.hours() + 'h ' : ' ') + (duration.minutes() ? duration.minutes() + 'm ' : ' ') + (duration.seconds() + 's');
    }
    else {
        var duration = moment.duration(moment(current).diff(moment(startedAt)));
        return duration.minutes() === 0 ? '<1 min' : "" + (duration.days() ? duration.days() + ' days ' : ' ') + (duration.hours() ? duration.hours() + ' hrs ' : ' ') + duration.minutes() + " mins";
    }
};
var getAvatarUrl = function (username) {
    var url = username ? "https://staff-avatars.prod.atl-paas.net/avatar/" + username + "?size=Large" : '';
    return url;
};
var WorkflowsTable = function (_a) {
    var workflows = _a.workflows, isLoading = _a.isLoading, workflowId = _a.workflowId, date = _a.date, history = _a.history, service = _a.service;
    var _b = useState({
        workflowId: workflowId
    }), modal = _b[0], setModal = _b[1];
    var formatRows = function (workflows) { return workflows.map(function (workflow) { return ({
        key: workflow.id,
        cells: [
            {
                key: 'id',
                content: (React.createElement("div", null,
                    React.createElement(NameWrapper, null,
                        React.createElement(AvatarWrapper, null,
                            React.createElement(Avatar, { name: workflow.createdBy ? workflow.createdBy.displayName || workflow.createdBy.id : "", size: "medium", src: workflow.createdBy ? getAvatarUrl(workflow.createdBy.id) : "" })),
                        React.createElement(Link, { onClick: function () { return setModal({ workflowId: workflow.id }); } }, workflow.id))))
            },
            {
                key: 'startedAt',
                content: moment(workflow.startedAt).format("MMM DD YYYY HH:mm A")
            },
            {
                key: 'updatedAt',
                content: statusDone(workflow.status) ? moment(workflow.updatedAt).format("MMM DD YYYY HH:mm A") : ''
            },
            {
                key: 'duration',
                content: getDurationString(workflow.startedAt, workflow.updatedAt, workflow.status, date)
            },
            {
                key: 'status',
                content: getStatusIcon(workflow.status)
            }
        ]
    }); }); };
    var rows = formatRows(workflows);
    var workflow = workflows.find(function (flow) { return flow.id === modal.workflowId; });
    return (React.createElement("div", null,
        React.createElement(DynamicTable, { caption: "Workflows", head: head, rows: rows, rowsPerPage: 10, defaultPage: 1, loadingSpinnerSize: "large", isFixedSize: true, isLoading: isLoading, emptyView: React.createElement("div", null, "There are no workflows for this service") }),
        workflow &&
            React.createElement(WorkflowModal, { isOpen: !!workflow, onClose: function () { return setModal(__assign(__assign({}, modal), { workflowId: undefined })); }, workflow: workflow, date: date, history: history, service: service })));
};
export default WorkflowsTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
